var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-left-button_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,1C22.084,1,1,22.084,1,48s21.084,47,47,47s47-21.084,47-47S73.916,1,48,1z M48,89C25.393,89,7,70.607,7,48 S25.393,7,48,7s41,18.393,41,41S70.607,89,48,89z M50.09,67.453c-0.002,0-0.167-0.067-0.47-0.357 c-0.029-0.028-0.06-0.057-0.091-0.084l-9.618-8.67c0.002-0.002-0.554-0.523-0.554-0.523l0.052-0.055l-1.432-1.382h-11.84l8.3,7.79 l1.806-1.924c0,0.041-1.749,1.981-1.749,1.981l9.637,8.688c2.157,2.045,4.278,2.508,5.755,2.508c0.083,0,0.164-0.002,0.243-0.005 c1.451-0.05,3.6-0.571,5.596-2.771l-5.752-5.221C50.019,67.433,50.059,67.441,50.09,67.453z M36.362,62.122l0.828-0.882 C37.19,61.24,36.362,62.158,36.362,62.122z M77.008,48c0,2.209-1.791,4-4,4h-25H22.993c-1.647,0-3.127-1.011-3.726-2.545 c-0.599-1.535-0.196-3.28,1.016-4.397l23.859-21.982c2.237-2.146,4.491-2.552,5.99-2.496c1.451,0.05,3.6,0.572,5.596,2.771 l-5.752,5.22c0.044-0.004,0.084-0.013,0.115-0.025c-0.002,0.001-0.167,0.068-0.47,0.358L33.237,44h14.771h25 C75.217,44,77.008,45.791,77.008,48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftButton);
export default __webpack_public_path__ + "static/media/arrow-left-button.eb61187996689d109c57f266c66e2570.svg";
export { ForwardRef as ReactComponent };